import React from 'react';
import NumberFormat from 'react-number-format';

import { Count } from '../pages/outlet-crew/Home.type';

const TableInput = ({
	row,
	updateData,
	addProductCount,
	onKeyPress,
	isSuccess,
	counts,
	categoryName,
	idScheduler,
}) => {
	const findCounts: Count =
		counts?.find((count) => count?.productId === row.original.productId);
	return (
		<NumberFormat
			disabled={isSuccess}
			thousandSeparator="."
			decimalSeparator=","
			allowNegative={false}
			value={findCounts?.counted || ''}
			placeholder="0"
			onChange={(event) =>
				updateData(row.original.productId, event.target.value, categoryName)
			}
			type="text"
			onBlur={(event) =>
				addProductCount(row.original.productId, event.target.value, idScheduler)
			}
			onKeyPress={(event) => onKeyPress(event)}
			className={
				isSuccess
					? 'laptop:w-34 tablet:w-34 mobile:w-22 h-11 flex text-right rounded-lg py-2 px-3 bg-gray-gray300 outline-none text-gray-gray500 tablet:text-large mobile:text-regular font-interRegular'
					: 'laptop:w-34 tablet:w-34 mobile:w-22 h-11 flex text-right rounded-lg py-2 px-3 border border-gray-gray400 outline-none text-gray-gray700 tablet:text-large mobile:text-regular font-interRegular focus:border-1.5 focus:border-gray-gray700'
			}
		/>
	);
};

export default TableInput;
